/* ============================================================
   data.ts — шаги для HowItWorksSection (страница /residents)
   Как жителю начать пользоваться платформой — 3 шага
   ============================================================ */

/** Описание одного шага онбординга жителя */
export interface HowItWorksStep {
    /** Порядковый номер шага — строка "1", "2", "3" */
    number: string;
    /** Краткое название шага */
    title: string;
    /** Развёрнутое описание */
    description: string;
}

/** Последовательность шагов для начала работы с платформой */
export const HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
    {
        number: "1",
        title: "Скачайте приложение",
        description:
            "Зарегистрируйтесь за 2 минуты — нужен только email и номер квартиры.",
    },
    {
        number: "2",
        title: "Привяжите квартиру",
        description:
            "Введите адрес — система автоматически найдёт ваш ЖК и подключит все услуги.",
    },
    {
        number: "3",
        title: "Пользуйтесь",
        description:
            "Оплачивайте счета, передавайте показания, подавайте заявки — всё в одном месте.",
    },
];
